<template>
	<div class="button app-delete-button">
		<div v-show="!active" @click.prevent="click">
			<slot></slot>
		</div>
		<div v-show="active">
			<span
				class="has-text-success has-cursor-pointer"
				@click.prevent="confirm"
				><dc-icon icon="check" size="lg" library="fas"></dc-icon
			></span>
			<span
				class="has-text-danger has-cursor-pointer"
				@click.prevent="cancel"
				><dc-icon icon="times" size="lg" library="fas"></dc-icon
			></span>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppDeleteButton",
	data() {
		return {
			active: false
		};
	},
	methods: {
		click(event) {
			this.active = true;
			setTimeout((_) => (this.active = false), 3000);
		},
		confirm() {
			this.$emit("click", event);
		},
		cancel() {
			this.active = false;
		}
	}
};
</script>

<style lang="scss">
.app-delete-button {
	min-width: 140px;
}
</style>
